import { useQuery } from '@tanstack/react-query'
import type { BrandId, Channel, ContentType } from '@hub/shared'
import { request } from './api.js'

export interface PerformanceRow {
  id: string
  brand: BrandId
  title: string
  type: ContentType
  channels: Channel[]
  start: string
  sources: { kind: string; ref: string; label: string; metrics: Record<string, number>; at: string | null }[]
}

export function usePerformance(brand: string[], from?: string) {
  const params = new URLSearchParams()
  if (brand.length) params.set('brand', brand.join(','))
  if (from) params.set('from', from)
  return useQuery({
    queryKey: ['performance', brand, from],
    queryFn: () => request<{ items: PerformanceRow[] }>(`/performance?${params}`).then((r) => r.items),
    placeholderData: (previous) => previous,
  })
}

export const METRIC_LABEL: Record<string, string> = {
  sent: 'Versendet',
  delivered: 'Zugestellt',
  opens: 'Öffnungen',
  clicks: 'Klicks',
  openRate: 'Öffnungsrate',
  clickRate: 'Klickrate',
  unsubscribes: 'Abmeldungen',
  reach: 'Reichweite',
  impressions: 'Impressionen',
  likes: 'Likes',
  comments: 'Kommentare',
  shares: 'Geteilt',
  saves: 'Gespeichert',
  views: 'Aufrufe',
}

export function formatMetric(key: string, value: number): string {
  if (key.endsWith('Rate')) return `${value.toLocaleString('de-DE', { maximumFractionDigits: 1 })} %`
  return value.toLocaleString('de-DE')
}
